import { Communicator } from '../../../concepts/objects';
import { Rect } from '../../../platform/geom/Rect';
import { ActiveObject, resolve } from '../../Container';
import { Annotation } from './Annotation';
import { AnnotationStore } from './AnnotationStore';
import { CanvasPing, UIPing } from './Ping';
import { PingStore } from './PingStore';

export class GesturesController extends ActiveObject {

    @resolve(Communicator) private comms!: Communicator;
    @resolve(AnnotationStore) private annotations!: AnnotationStore;
    @resolve(PingStore) private pings!: PingStore;

    private lastPingAt = -500;

    public start(): void {
        this.burden(
            this.comms.recv('annotate', (_sender, [id, group, color, data]) => {
                this.realizeCanvasAnnotation(id, group, color, data);
            }),
            this.comms.recv('ping', (_sender, [color, region]) => {
                this.realizeCanvasPing(color, Rect.fromArray(region), CanvasPing.defaultTtl);
            }),
            this.comms.recv('ping', (_sender, [color, id]) => {
                this.realizeUIPing(color, id);
            }),
        );
    }

    public annotate(id: string, group: string, color: string, data: number[]) {
        this.realizeCanvasAnnotation(id, group, color, data.slice()); // Slice here is to stop issues with immerjs
        // this.comms.sendReduced('annotate', [id, color, data], `annotate/${id}`);
        this.comms.send('annotate', [id, group, color, data]);
    }

    public pingCanvas(color: string, region: Rect): void {
        const now = performance.now();
        const cooldown = (now - this.lastPingAt) <= CanvasPing.cdt;
        if (cooldown) return;
        this.realizeCanvasPing(color, region, CanvasPing.defaultTtl);
        this.comms.send('ping', [color, region.toArray()]);
        this.lastPingAt = now;
    }

    private realizeCanvasAnnotation(id: string, group: string, color: string, data: number[]) {
        const subject = this.annotations.getById(id) ?? this.annotations.add(new Annotation(id, group, color));
        subject.mutate({ data });
        const set = this.annotations.getByGroup(subject.group);
        const until = (new Date()).getTime() + Annotation.ttl;
        for (const tm of set) {
            tm.mutate({ until });
        }
        this.scheduler.timeout(group, Annotation.ttl * 1.1, () => {
            this.annotations.removeByGroup(group);
        });
    }

    private realizeCanvasPing(color: string, region: Rect, ttl: number) {
        const subject = this.pings.add(new CanvasPing(color, region, ttl));
        this.scheduler.timeout(subject.id, ttl * 1.1, () => {
            this.pings.remove(subject);
        });
    }

    public pingUI(color: string, id: string): void {
        this.realizeUIPing(color, id);
        this.comms.send('ping', [color, id]);
    }

    private realizeUIPing(color: string, id: string) {
        const subject = this.pings.add(new UIPing(color, id));
        this.scheduler.timeout(subject.id, UIPing.ttl * 1.1, () => {
            this.pings.remove(subject);
        });
    }
}
